/**
 * @description Manifest extension
 */
export enum Manifest {
	MPD = 'mpd',
	M3U8 = 'm3u8',
}